import { ModalSocialOfferProvider } from "../ModalSocialOffer/context";
import { DrawerSocialOfferStyled, classes } from "./styles";

export interface IBaseDrawerSocialOfferProps {
  open: boolean;
  onClose: () => void;
  header: React.ReactNode;
  body: React.ReactNode;
  anchor?: "left" | "top" | "right" | "bottom";
}

export const BaseDrawerSocialOffer = ({
  open,
  onClose,
  header,
  body,
  anchor = "right",
}: IBaseDrawerSocialOfferProps) => {
  return (
    <ModalSocialOfferProvider>
      <DrawerSocialOfferStyled anchor={anchor} open={open} onClose={onClose} className={classes.root}>
        {header}
        {body}
      </DrawerSocialOfferStyled>
    </ModalSocialOfferProvider>
  );
};
